import { cssVar } from '@mfw/common';
import type { SliderProps } from '@mui/material/Slider';
import type { Theme } from '@mui/material/styles';

import { sliderClasses } from '@mui/material/Slider';

import type { OnSurfaceMarkFamily } from '../../onSurface';

import { ON_SURFACE_MARK_FAMILIES, onSurfaceMark } from '../../onSurface';

// ----------------------------------------------------------------------

export function slider(theme: Theme) {
  const lightMode = theme.palette.mode === 'light';

  return {
    MuiSlider: {
      styleOverrides: {
        markLabel: {
          color: cssVar.text.secondary,
          fontSize: 13,
        },
        rail: {
          opacity: 0.32,
        },
        root: ({ ownerState }: { ownerState: SliderProps }) => ({
          [`&.${sliderClasses.disabled}`]: {
            color: 'red',
          },
          // The track and the thumb are thin marks drawn on the page, and MUI
          // paints them (and the rail, at 32% opacity) all from the root's
          // `currentColor` = `<color>.main`, 1.7:1 on a light tenant. One
          // colour here routes all three to the mark step.
          ...(ON_SURFACE_MARK_FAMILIES.includes(
            ownerState.color as OnSurfaceMarkFamily,
          ) && {
            color: onSurfaceMark[ownerState.color as OnSurfaceMarkFamily],
          }),
        }),
        valueLabel: {
          backgroundColor: theme.palette.grey[lightMode ? 800 : 700],
          borderRadius: 8,
        },
      },
    },
  };
}
